module.exports = __webpack_public_path__ + "static/media/no-notif.700248b0.svg";